import React from 'react'
import { Box, Typography } from 'components'
import { Chip } from '@material-ui/core'
import { usePrograms } from 'utils'

export function AlumniFilter({ filterState: state, setFilterState: setState }) {
  const { programs } = state
  const programsList = usePrograms()
  
  const alumniTags = programsList || []

  const onAlumniTagChange = (tag) => {
    const currentPrograms = programs || []
    
    if (currentPrograms.some(p => p.id === tag.id)) {
      setState({ ...state, programs: currentPrograms.filter(p => p.id !== tag.id) })
    } else {
      setState({ ...state, programs: [...currentPrograms, tag] })
    }
  }
  
  return (
    <Box py={1.5} flex={1} flexVariant="space-between align-center" minHeight="fit-content">
      <Box display="flex" alignItems="center" flex={1} flexDirection="column">
        <Typography variant="subtitle1" style={{ marginBottom: '10px' }}>Alumni</Typography>
        <Box
          display="flex"
          alignItems="center"
          flex={1}
          flexDirection="row"
          flexWrap="wrap"
          width="30dvw">
          {alumniTags.map((tag) => {
            const isSelected = programs && programs.some(p => p.id === tag.id)
            return (
              <Chip 
                label={tag.name} 
                key={tag.id} 
                style={{ margin: 2 }} 
                variant={isSelected ? 'default' : 'outlined'} 
                color='primary'
                onClick={() => onAlumniTagChange(tag)} 
              />
            )
          })}
        </Box>
      </Box>
    </Box>
  )
}
